/**
 * Authentication API functions
 * Core login/logout/profile APIs for AimerPay
 */
import { request } from '@umijs/max';

/** Get current user profile - GET /api/auth/profile */
export async function currentUser(options?: Record<string, any>) {
  return request<API.ProfileResult>('/api/auth/profile', {
    method: 'GET',
    ...(options || {}),
  });
}

/** Logout - POST /api/auth/logout */
export async function outLogin(options?: Record<string, any>) {
  return request<API.LogoutResult>('/api/auth/logout', {
    method: 'POST',
    ...(options || {}),
  });
}

/** Login - POST /api/auth/login */
export async function login(body: API.LoginParams, options?: Record<string, any>) {
  return request<API.LoginResult>('/api/auth/login', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: body,
    skipErrorHandler: true, // Handle errors in login page
    ...(options || {}),
  });
}

/** Refresh Token - POST /api/auth/refresh */
export async function refreshToken(refreshTokenValue: string, options?: Record<string, any>) {
  return request<API.RefreshTokenResult>('/api/auth/refresh', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    data: { refreshToken: refreshTokenValue },
    ...(options || {}),
  });
}
